function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import "core-js/modules/es.array.flat-map.js";
import "core-js/modules/es.array.unscopables.flat-map.js";
import "core-js/modules/es.promise.finally.js";
import "core-js/modules/web.dom-collections.iterator.js";
import * as request from '@eika-infrastruktur/request';
import { getToken } from '../util/sessionStorage';
import DefaultRestApplicationClient from './default-rest-application-client';
const CONTEXT_PATH = '/felles-kyc-declaration-web';
const SERVICE_PATH = "".concat(CONTEXT_PATH, "/rest/resource");
export const paramsToString = queryParams => {
  if (queryParams === undefined || Object.keys(queryParams).length === 0) return '';
  const queryString = Object.keys(queryParams).filter(key => queryParams[key]).flatMap(key => {
    const value = queryParams[key];
    if (value instanceof Array) {
      return value.map(element => "".concat(key, "=").concat(element));
    }
    return ["".concat(key, "=").concat(value)];
  }).join('&');
  return "?".concat(encodeURI(queryString));
};
export class DefaultHttpClient {
  constructor(requestClient) {
    this.requestClient = requestClient;
    // don't send duplicate requests
    _defineProperty(this, "ongoingResponseCache", new Map());
    this.requestClient = requestClient;
  }
  request(_ref) {
    let {
      url,
      method,
      queryParams,
      data,
      options
    } = _ref;
    const resourceUrl = "".concat(SERVICE_PATH, "/").concat(url).concat(paramsToString(queryParams));
    const token = getToken();
    const clientOptions = {
      headers: _objectSpread(_objectSpread({}, options), {}, {
        'X-declaration-web-token': token
      })
    };
    const cacheKey = "".concat(method, " ").concat(resourceUrl, " ").concat(token);
    const {
      ongoingResponseCache
    } = this;
    const ongoingResponse = ongoingResponseCache[cacheKey];
    if (ongoingResponse) return ongoingResponse;
    const response = this.doRequest(method, resourceUrl, clientOptions, data);
    ongoingResponseCache[cacheKey] = response;
    response.finally(() => ongoingResponseCache.delete(cacheKey));
    return response;
  }
  doRequest(method, resourceUrl, clientOptions, data) {
    switch (method) {
      case 'GET':
        return this.requestClient.get(resourceUrl, clientOptions);
      case 'POST':
        return this.requestClient.post(resourceUrl, data, clientOptions);
      case 'PUT':
        return this.requestClient.put(resourceUrl, data, clientOptions);
      case 'DELETE':
        return this.requestClient.del(resourceUrl, clientOptions);
      default:
        return Promise.reject(Error('missing method'));
    }
  }
}
export default new DefaultRestApplicationClient(new DefaultHttpClient(request));